<template>
  <div class="app-main">
    <!-- <PageReel class="reel" /> -->
    <div class="app-page-content">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </div>
    <!-- <PageReel class="reel" pos="bottom" /> -->
  </div>
</template>

<script>
import PageReel from './PageReel'
export default {
  name: 'AppMain',
  components: { PageReel },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="less" scoped>
.app-main {
  width: 100%;
  padding-bottom: 60px;
  // overflow: hidden;
  .app-page-content {
    width: auto;
    max-width: @pageContentWidth;
    background: @themeColor5;
    margin: 0 auto;
    min-height: 400px;
  }
}
@media screen and (max-width: @xsW) {
.app-main {
  padding-bottom: 0;
  .reel {
    display: none;
  }
  .app-page-content {
    width: 100%;
  }
}
}
</style>
